import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom'; 


const ProtectedRoute = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/session/validate`, {
                method: "GET",
                credentials: "include" // Include cookies in the request
            })
        .then((response) => {
            if (response.ok) {
                setIsAuthenticated(true);
            } else {
                setIsAuthenticated(false);
            }
        })
        .catch(() => setIsAuthenticated(false));
    }, []);

  // Show a loading spinner while checking authentication
    if (isAuthenticated === null) {
        return <div>Loading...</div>;
    }

  // Redirect to login if not authenticated
    if (!isAuthenticated) {
        return navigate("/login");
    }

    // Render the protected component if authenticated
    return children;
};

export default ProtectedRoute;
